import React from 'react';
import { Row, Col } from 'react-bootstrap';
import TitleLight from '../../components/Text/TitleLight';
import i18n from '../../locales';
import MainStyles from '../../styles/MainStyles';
import './index.css'
import WhiteButtonOutline from '../../components/Buttons/WhiteButtonOutline';
import TextError from '../../components/Text/TextError';
import BannerHeader from '../../components/Headers/BannerHeader';
let { basePath } = require('../../shared/constants');

const PageError = (props) => {
  let errorMsg = props.location.search.indexOf('expired') < 0 ? i18n.t('error.err_msg') : i18n.t('error.session_expired')

  return (
    <div className='errorpage-container'>
      <BannerHeader/>
      <Row className='errorpage-row' style={{ ...MainStyles.containerGradient }}>
        <Col sm={{ span: 10, offset: 1 }}>
          <Row style={{alignItems: 'center'}}>
            <Col sm={{ span: 6, offset: 1 }} md={{ span: 5, offset: 1 }}>
              <TitleLight
                text={i18n.t('error.title')}
                size={'medium'}
                color={MainStyles.colors.white}
              />
              <br/>
              <TitleLight
                text={i18n.t('error.title_services')}
                size={'medium'}
                color={MainStyles.colors.white}
              />
              <br/>
              <TextError
                text={errorMsg}
              />
            </Col>
            <Col style={{textAlign: 'center'}} sm={{ span: 3, offset: 1 }} md={{ span: 3, offset: 2 }}>
              <WhiteButtonOutline
                text={i18n.t('general.back')}
                isRounded={true}
                onClick={() => {
                  window.location.href = `${basePath()}/login`
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default PageError
